import React, { Component } from 'react';
import styled from 'styled-components';
import { changeLocation } from 'api/Location';

import Auth from '../../../routes/Auth';
import OnboardingLayout from './OnboardingLayout';
import MGLogo from '../../../containers/assets/LandingPageLogo4.png';
import { getNextOnboardingStep } from './onboardingRouting';

const InnerCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 62px 49px 73px;
`;

const Logo = styled.img`
  height: 90px;
  width: auto;
  max-width: 358px;
  object-fit: contain;
`;

const Heading = styled.h1`
  margin: 24px 0 6px;
  font-family: 'Mukta Mahee', 'Mukta Vaani', sans-serif;
  font-size: 30px;
  line-height: 60px;
  font-weight: 700;
  color: #2F4166;
  max-width: 100%;
  white-space: nowrap;
`;

const Subheading = styled.p`
  margin: 0 0 36px;
  font-family: 'Mukta Vaani', 'Mukta Mahee', sans-serif;
  font-size: 20px;
  line-height: 40px;
  font-weight: 400;
  color: rgba(0, 27, 59, 0.94);
  max-width: 645px;

  strong { font-weight: 700; }
`;

const StyledButton = styled.button`
  width: 162px;
  height: 41px;
  border: none;
  border-radius: 16px;
  color: #FFFFFF;
  font-family: 'Mukta Mahee', 'Mukta Vaani', sans-serif;
  font-size: 24px;
  font-weight: 700;
  cursor: pointer;
  background: linear-gradient(101.768deg, #FF5252 2.88%, #70A1FF 100%);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);

  &:hover { opacity: 0.94; }
`;

class Intro extends Component {
  handleGetStarted = () => {
    // Route via the shared utility so partial-onboarding users skip
    // path-choice and go straight to whichever step is still needed.
    const setup = this.props.onboardingSetup || { hasGame: false, hasSurvey: false };
    const user = Auth.getUser();
    const onboardComplete = !!(user && user.onboard !== 0);
    changeLocation(getNextOnboardingStep('intro', {
      hasGame: setup.hasGame,
      hasSurvey: setup.hasSurvey,
      onboardComplete,
    }));
  };

  render() {
    return (
      <OnboardingLayout
        cardMaxWidth={729}
        cardPadding="0"
        cardBackground="#FFFFFF"
      >
        <InnerCard>
          <Logo src={MGLogo} alt="Market Games" />
          <Heading>Welcome to the Intro to Business Challenge</Heading>
          <Subheading>
            A <strong>team-based</strong> multi-round simulation where students
            make decisions, get feedback, and experience the{' '}
            <strong>integrated nature of business</strong>.
          </Subheading>
          <StyledButton onClick={this.handleGetStarted}>Get Started</StyledButton>
        </InnerCard>
      </OnboardingLayout>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/Intro.js